import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import RegionSelector from '../regions/RegionsSelector';
import ItemsPopularity from '../general/ItemsPopularity';
import ApiVolumesTrims from '../../api/volumestrims';

import { log as actionsLog } from '../../store/actions';

const { addToLog } = actionsLog;

const TrimsPopularity = ({ model, volume, trims }) => {

    let dispatch = useDispatch();

    let selectedRegion = useSelector(store => store.regions.selectedRegion);

    let [popularityIncrement, setPopularityIncrement] = useState(0);

    let [popularTrims, setPopularTrims] = useState([]);
    let [unpopularTrims, setUnpopularTrims] = useState([]);

    useEffect(() => {
        ApiVolumesTrims.getPopularTrimsByModelAndVolume(selectedRegion.id, model.id, volume.id).then(json => {
            setPopularTrims(json.trims);
        });
        ApiVolumesTrims.getUnpopularTrimsByModelAndVolume(selectedRegion.id, model.id, volume.id).then(json => {
            setUnpopularTrims(json.trims);
        });
    }, [trims, selectedRegion, popularityIncrement]);

    const moveToPopular = trim => {
        let proceed = window.confirm(`Are you sure??`);
        if (proceed) {
            ApiVolumesTrims.setPopularTrimByModelAndVolume(selectedRegion.id, model.id, volume.id, trim.id).then(resp => { 
                setPopularityIncrement(popularityIncrement+=2);
                dispatch(addToLog(resp));
            });
        }
    };

    const moveToUnpopular = trim => {
        let proceed = window.confirm(`Are you sure??`);
        if (proceed) {
            ApiVolumesTrims.setUnpopularTrimByModelAndVolume(selectedRegion.id, model.id, volume.id, trim.id).then(resp => { 
                setPopularityIncrement(popularityIncrement+=2);
                dispatch(addToLog(resp));
            });
        }
    };

    const moveAllToPopular = () => {
        let proceed = window.confirm(`Are you sure??`);
        if (proceed) {
            ApiVolumesTrims.setAllPopularTrimsByModelAndVolume(selectedRegion.id, model.id, volume.id).then(resp => { 
                setPopularityIncrement(popularityIncrement+=2);
                dispatch(addToLog(resp));
            });
        }
    };

    const moveAllToUnpopular = () => {
        let proceed = window.confirm(`Are you sure??`);
        if (proceed) {
            ApiVolumesTrims.setAllUnpopularTrimsByModelAndVolume(selectedRegion.id, model.id, volume.id).then(resp => { 
                setPopularityIncrement(popularityIncrement+=2);
                dispatch(addToLog(resp));
            });
        }
    };

    return (
        <div className="border border-gray-700">
            <RegionSelector title="Set popularity for trims in selected region" />
            <ItemsPopularity 
                popularItems={popularTrims} 
                unpopularItems={unpopularTrims} 
                fxMoveToPopular={moveToPopular} 
                fxMoveToUnpopular={moveToUnpopular} 
                fxMoveAllToPopular={moveAllToPopular} 
                fxMoveAllToUnpopular={moveAllToUnpopular} 
                titlePopular="Popular trims"
                titleUnpopular="Unpopular trims" />
        </div>
    );
}

export default TrimsPopularity;